import React from 'react';
import PatientSummarySearch from '../../components/history/modals/PetientSummarySearch';

const MedicalHistoryPage = () => {

    return (
      <PatientSummarySearch autoOpen={true} />
    );
};

export default MedicalHistoryPage;
